var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 533.3 666.7",
    style: {
      enableBackground: "new 0 0 533.3 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500,100h-33.3V33.3c0-18.4-14.9-33.3-33.3-33.3S400,14.9,400,33.3V100h-33.3c-18.4,0-33.3,14.9-33.3,33.3v400 c0,18.4,14.9,33.3,33.3,33.3H400v66.7c0,18.4,14.9,33.3,33.3,33.3s33.3-14.9,33.3-33.3v-66.7H500c18.4,0,33.3-14.9,33.3-33.3v-400 C533.3,114.9,518.4,100,500,100z M466.7,500H400V166.7h66.7V500z M233.3,66.7h-66.7V33.3c0-18.4-14.9-33.3-33.3-33.3 S100,14.9,100,33.3v33.3H33.3C14.9,66.7,0,81.6,0,100v466.7C0,585.1,14.9,600,33.3,600H100v33.3c0,18.4,14.9,33.3,33.3,33.3 s33.3-14.9,33.3-33.3V600h66.7c18.4,0,33.3-14.9,33.3-33.3V100C266.7,81.6,251.7,66.7,233.3,66.7z M200,533.3H66.7v-400H200V533.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxIcon);
export default __webpack_public_path__ + "static/media/tax_icon.d42b9d86066747f3d6cfe0b3db13cc54.svg";
export { ForwardRef as ReactComponent };